import React from 'react';
const BreadCumb = ({image}) => {
    return (
        <div className="banner-area bg-light">
            <div className="container p-0 pt-2 pb-2">
                <div className="row g-0">
                    <div className="col-xxl-12">
                        <div className="banner__img-wrapper">
                            <img
                                src={`${process.env.PUBLIC_URL}/${image}`}
                                alt="Banner"
                                className="img-fluid w-100"
                                style={{ borderRadius:"15px" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BreadCumb;